export default __webpack_public_path__ + "static/media/ClientIcon.f6e703dd.svg";